import { useTranslation } from "react-i18next"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { CircleAlert } from "lucide-react"

interface UnsavedChangesDialogProps {
  isOpen: boolean
  onClose: () => void
  onLeave: () => void
}

const UnsavedChangesDialog = ({ isOpen, onClose, onLeave }: UnsavedChangesDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-md" data-testid="unsaved-changes-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <CircleAlert className="h-5 w-5 text-destructive" />
            {t("productPage.unsavedChanges")}
          </DialogTitle>
          <DialogDescription>{t("productPage.unsavedChangesDescription")}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2 sm:justify-between">
          <Button variant="ghost" onClick={onClose} data-testid="unsaved-changes-dialog-stay">
            {t("productPage.keepEditing")}
          </Button>
          <Button
            variant="destructive"
            onClick={onLeave}
            data-testid="unsaved-changes-dialog-leave"
          >
            {t("productPage.leavePage")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default UnsavedChangesDialog
